export default "__VITE_ASSET__CskcOtTY__"